import { atom } from 'jotai';

import type { Plan } from '@/fixtures/plans';

const signUpAccountTypeAtom = atom<Plan['name']>('Creator');

/**
 * `?plan=` slug the user was buying when the auth modal interrupted them.
 *
 * Set when a plan screen hands off to log in, read once the login succeeds,
 * and cleared by `AccountModalsProvider` on every modal close — including
 * abandonment, so a dropped intent can't push a later, unrelated login into
 * checkout. `signUpAccountTypeAtom` can't serve here: it defaults to a plan,
 * is never reset, and several entry points leave it stale (DEV-6629).
 */
const pendingCheckoutPlanAtom = atom<string | null>(null);

export { pendingCheckoutPlanAtom, signUpAccountTypeAtom };
